
<template>
  <div class="product-detail">
    <yk-breadcrumb class="ykbread" :typeName="typeName" type="product"></yk-breadcrumb>
    <div class="detailImage">
      <div class="imgList">
        <div class="miniList">
          <div class="images" v-for="(item, index) in imgList" :key="'imgList'+index" :class="currentIndex===index?'active':''" @click="clickImg(item, index)">
            <img class="image" :src="item">
          </div>
        </div>
        <div class="img">
          <img :src="imgList[currentIndex]">
        </div>
      </div>
      <div class="info">
        <p class="name">{{name}}</p>
        <p class="text" v-html="brief"></p>
        <div class="btn" @mouseover="showQrcode=true" @mouseout="showQrcode=false">购买咨询</div>
        <div class="qrcode" v-show="showQrcode">
          <img :src="require('../../assets/images/product/qrcode.jpg')">
        </div>
      </div>
    </div>
    <div class="tabList">
      <p class="item" :class="activeTab===index?'active':''" v-if="showTab(index)" v-for="(item, index) in tabList" :key="'tab'+index" @click="activeTab = index">{{item.name}}</p>
    </div>
    <div class= "tabContent" v-show="activeTab===0" v-html="tabList[0].content"></div>
    <div class="tabContent" v-show="activeTab===1" v-html="tabList[1].content" ></div>
    <div class="tabContent machineFittings" v-show="activeTab===2 && type === 'product'" >
      <div class="item" v-for="(item, index) in tabList[2].content" :key="'machineFittings'+index" @click="clickItem(item, 'fittings')">
        <img :src="item.fittingPic" :alt="item.fittingName">
        <p class="name">{{item.fittingName}}</p>
      </div>
    </div>
    <div class="tabContent" v-show="activeTab===3">
      <video class="video" v-for="(item, index) in tabList[3].content" :key="'video'+index" controls name="media" v-if="tabList[3].content.length > 0">
        <source :src="item">
      </video>
    </div>
    <div class="successCase">
      <div class="box">
        <img class="pic" :src="successInfo.casePic" alt="成功案例">
      </div>
    </div>
    <div class="modelList" v-if="nominateList.length>0">
      <p class="title">其他型号</p>
      <div class="listBox">
        <div class="item" v-for="(item, index) in nominateList" :key="'model'+index" @click="clickItem(item, 'product')">
          <img :src="item.productPic" :alt="item.productName" :title="item.productName">
          <p class="name">{{item.productName}}</p>
        </div>
      </div>
    </div>
    <div class="modelList" v-if="similarProducts.length>0">
      <p class="title">相似产品</p>
      <div class="listBox">
        <div class="item" v-for="(item, index) in similarProducts" :key="'similarProducts'+index" @click="clickItem(item, 'product')">
          <img :src="item.productPic" :alt="item.productName" :title="item.productName">
          <p class="name">{{item.productName}}</p>
        </div>
      </div>
    </div>
    <div class="modelList" v-if="relatedNews.length>0">
      <p class="title">电子手册</p>
      <div class="listBox">
        <div class="item" v-for="(item, index) in relatedNews" :key="'relatedNews'+index" @click="clickNews(item)">
          <img :src="item.pic" :alt="item.title" :title="item.title">
          <p class="name">{{item.title}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ykBreadcrumb from '../../components/base/breadcrumb.vue'
export default {
  data () {
    return {
      imgList: [],
      name: '',
      brief: '',
      currentIndex: 0,
      timer: null,
      tabList: [
        {name: '优势特征', content: ''},
        {name: '参数细节', content: ''}, 
        {name: '拓展配件', content: []}, 
        {name: '资料视频', content: []},
      ],
      activeTab: 0,
      successList: [
      ],   
      type: '',
      swiperOption_1: {
        slidesPerView: 3,
        pagination: '.swiper-pagination',
        paginationType: 'fraction',
        observeParents: true,
        observer: true,
        navigation: { // 设置前进后退按钮
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },        
        autoplay: { // 设置自动轮播
          delay: 3000,
          disableOnInteraction: false,
        },
        loop: true,
      },
      nominateList: [],
      productId: 0,
      successInfo: {},
      similarProducts: [],
      relatedNews: [],
      showQrcode: false,
    }
  },
  computed: {
    typeName () {
      let typeList = this.bannerList.find(val => {return val.typeLabel === 'product'})
      if (typeList) {
        let obj = typeList.child.find(val => {return val.id == this.$route.query.typeId})
        if (obj) {
          return obj.name
        }
      }   
    }
  },
  mounted () {
    this.activeTab = 0
    this.getData()
    this.timer = setInterval(() => {
      this.currentIndex + 1 > this.imgList.length - 1 ? this.currentIndex = 0 : this.currentIndex++
    }, 5000);
  },
  methods: {
    showTab (index) {
      if (this.type === 'fittings' && index === 2) {
        return false
      }
      return true
    },
    getData () {
      if (this.$route.query && this.$route.query.id && this.$route.query.type) {
        this.type = this.$route.query.type
        if (this.type === 'product') {
          this.$get(`/api/product/detail/${this.$route.query.id}`).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.imgList = res.data.pic
              this.tabList[0].content = res.data.advantage
              this.tabList[1].content = res.data.parameterDetails
              this.tabList[2].content = res.data.machineFittings || []
              this.tabList[3].content = res.data.vedios || []
              this.brief = res.data.productContent
              this.name = res.data.productName
              this.similarProducts = res.data.similarProducts || []
              this.relatedNews = res.data.relatedNews || []
            }
          })
        } else if (this.type === 'fittings') {
          this.$get(`/api/machine/fittings/detail/${this.$route.query.id}`).then(res => {
            if (res.code === 0) {
              this.imgList = res.data.pic
              this.tabList[0].content = res.data.advantage
              this.tabList[1].content = res.data.parameterDetails
              this.tabList[3].content = res.data.vedios || []
              this.activeTab = 0
              // this.tabList.splice(2, 1)
              this.brief = res.data.fittingContent
              this.name = res.data.fittingName
            }
          })
        }      
        if (this.$route.query.typeId) {    
          this.$get(`/api/product/nominate?navigationId=${this.$route.query.typeId}`).then(res => {
            this.nominateList = res.data || []
          })    
          this.$get(`/api/product/case?navigationId=${this.$route.query.typeId}`).then(res => {
            this.successInfo = res.data || {}
          })
        }        
      }
    },
    clickImg (item, index) {
      this.currentIndex = index
    },
    clickItem (item, type) {    
      let routeUrl = this.$router.resolve({
        path: '/productDetail',
        query: {id: item.id, typeId: this.$route.query.typeId, type: type}
      })
      window.open(routeUrl.href, '_blank')
    },
    clickNews (item) { 
      let routeUrl = this.$router.resolve({
        path: '/newsDetail',
        query: {newsId: item.id}
      })
      window.open(routeUrl.href, '_self')
    },
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  components: {ykBreadcrumb}
}
</script>
<style scoped lang="stylus">
.product-detail
  padding-top 50px
  .detailImage
    width $pageWidth
    margin 40px auto
    display flex
    .imgList
      width 55%
      display flex
      margin-right 3%
      .miniList
        width 22%
        margin-right 5%
        height 550px
        overflow-y auto
        .images
          height 110px
          border 1px solid #D3D3D3
          position relative
          overflow hidden
          margin-bottom 20px
          cursor pointer
          .image
            width 90%
            position absolute
            top 50%
            left 50%
            transform translate3d(-50%, -50%, 0)
        .active
          border 2px solid #ffaa00
      .img
        width 73%
        border 1px solid #D3D3D3
        position relative
        overflow hidden
        img
          width 98%
          position absolute
          top 50%
          left 50%
          transform translate3d(-50%, -50%, 0)
    .info
      width 40%
      color $c1
      .name
        font-size 40px
        line-height 50px
        font-weight 600
        margin 50px 0
      .text
        font-size 20px
        line-height 40px
        margin-bottom 50px
        margin-left 20px
      .btn
        width 400px
        color $c7
        font-size 30px
        text-align center
        border-radius  60px
        line-height 60px
        background-color #03459D
      .qrcode
        position absolute
        width 200px
        height 200px
  .tabList
    width $pageWidth
    margin 20px auto
    line-height 80px
    display flex
    background-color #F7F7F7
    .item
      flex 1
      text-align center
      font-size 30px
      color $c1
      cursor pointer
    .active
      color $c7
      background-color #03459D
  .tabContent
    width $pageWidth
    color $c1
    padding 20px
    background-color #F7F7F7
    margin 20px auto
    font-size 20px
    line-height 40px
    .wscnph
     width 
     img
      width 100%
    .video
      display block
      width 80%
      margin 10px auto
  .machineFittings
    display flex
    flex-wrap wrap
    .item
      width calc(25% - 12px)
      height 300px
      margin-right 16px
      cursor pointer
      img
        display block
        width 80%
        margin 0 auto
      .name
        font-size 18px
        color $c1
        text-align center
        margin-top 20px
      &:nth-of-type(4n)
        margin-right 0
  .successCase
    .box
      margin 0 auto
      .title
        padding 30px 0
        font-size 48px
        text-align center
        color $c1
      .html
        width $pageWidth
        margin 20px auto
        font-size 18px
        line-height 30px
      .pic
        width 100%
      .swiperBox
        position relative
        .listItemBox
          .itemBox
            position relative
            height 600px
            display flex
            flex-direction column
            justify-content flex-end
            .text
              width 90%
              font-size 20px
              color #656565
              padding 40px 28px
              line-height 30px
              background-color $c7
              border-radius 10px
              margin 0 auto 40px auto
              position relative
              &:before
                content ''
                display block
                position absolute
                bottom -20px
                left 50%
                transform translate3d(-50%, 0, 0)
                border 10px solid transparent
                border-top 10px solid $c7
            .img
              display block
              margin 0 auto
            .name
              text-align center
              font-size 18px
              color #fff
              margin 28px auto 0 auto
              line-height 30px
              width 50%
        .swiper-button-prev, .swiper-button-next
          position absolute
          top 50%
          width 35px
          height 68px
        .swiper-button-prev
          left -10%
          color #fff
          background-image url('../../assets/images/product/detail/l.png')
        .swiper-button-next
          right -10%
          background-image url('../../assets/images/product/detail/r.png')
  .modelList
    width $pageWidth
    margin 60px auto
    .title
      font-size 48px
      font-weight 600
      color $c1
      text-align center
      margin-bottom 40px
    .listBox
      display flex
      color $c1
      .item
        width calc(25% - 12px)
        margin-right 16px
        cursor pointer
        display flex
        flex-direction column
        justify-content space-between
        img
          display block
          width 80%
          margin 0 auto
        .name
          font-size 18px
          color $c1
          margin-top 20px
          text-align center
          no-wrap()
@media screen and (max-width: 900px)
  .product-detail
    padding-top 0
    .ykbread
      display none
    .detailImage
      width 100%
      margin 0 auto
      display block
      background-color $c7
      position relative
      .imgList
        width 100%
        height auto
        display block
        margin-top 8rem
        .miniList
          min-width 100%
          height 5rem
          display flex
          overflow-y hidden
          overflow-x auto
          .images
            width 30%
            height 80%
            margin 0 0.5rem
            border-radius 5px
            background-color $c7
        .img
          width 80%
          height 10rem
          position absolute
          top -10rem
          left 50%
          transform translate3d(-50%, 0, 0) scale(0.6)
          border none
      .info
        width 94%
        margin 0 auto
        background-color #03459D
        color $c7
        padding 0.8rem
        border-radius 10px
        .name
          font-size 1rem
          margin 1rem 0
          line-height 1.5rem
        .text
          font-size 0.8rem
          line-height 1.2rem
          margin-bottom 2rem

        .btn
          width 50%
          background-color $c7
          color #03459D
          font-size 1rem
          line-height 2rem
    .tabList
      width 94%
      margin 3% auto
      line-height 2rem
      .item
        font-size 0.8rem
    .tabContent
      width 94%
      margin 3% auto    
    .machineFittings
      .item
        width calc(50% - 0.5rem)
        margin-right 1rem
        height 10rem
        &:nth-of-type(2n)
          margin-right 0
    .successCase
      .box
        width 100%
        margin 0 auto
        .title
          width 96%
          margin 0 auto
          font-size 1.8rem
          padding 1.8rem 0 0.8rem 0
        .html
          width 96%
          margin 0.6rem auto
          font-size 0.8rem
        .swiperBox
          .listItemBox
            .itemBox
              .text
                width 95%
                font-size 0.4rem
                padding 0.4rem
                line-height 1rem
                margin-bottom 1rem
              .img
                width 50%
              .name
                width 80%
                font-size 0.5rem
                line-height 1rem
                margin-top 1rem
    .modelList
      width 100%
      margin 1rem auto 2rem auto
      .title
        font-size 1.6rem
        margin-bottom 1rem
      .listBox
        flex-wrap wrap
        .item
          width calc(50% - 0.5rem)
          margin-right 1rem
          &:nth-of-type(2n)
            margin-right 0
</style>
